(function () {
  var root = document.getElementById('MainProduct');
  if (!root) return;

  var mainImg = document.getElementById('ProductMainImage');
  root.querySelectorAll('.product-gallery__thumb').forEach(function (btn) {
    btn.addEventListener('click', function () {
      root.querySelectorAll('.product-gallery__thumb').forEach(function (b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');
      if (mainImg) mainImg.src = btn.getAttribute('data-full');
    });
  });

  var tabButtons = root.parentElement.querySelectorAll('.product-tabs__nav button');
  tabButtons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var target = btn.getAttribute('data-tab');
      tabButtons.forEach(function (b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');
      document.querySelectorAll('.product-tabs__panel').forEach(function (p) {
        p.classList.toggle('is-active', p.getAttribute('data-panel') === target);
      });
    });
  });

  var optionSelects = root.querySelectorAll('.product-option-select');
  if (optionSelects.length && window.__productVariants) {
    var updateVariant = function () {
      var selected = Array.from(optionSelects).map(function (s) { return s.value; });
      var match = window.__productVariants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === selected[i]; });
      });
      if (!match) return;
      var idInput = document.getElementById('ProductVariantId');
      if (idInput) idInput.value = match.id;
      var priceEl = document.getElementById('ProductPrice');
      if (priceEl) {
        var html = '';
        if (match.compare_at_price_money && match.compare_at_price_cents > match.price_cents) {
          html += '<s>' + match.compare_at_price_money + '</s>';
        }
        html += match.price_money;
        priceEl.innerHTML = html;
      }
      var addBtn = document.getElementById('AddToCartButton');
      if (addBtn) addBtn.disabled = !match.available;
      if (match.featured_image) mainImg.src = match.featured_image;
    };
    optionSelects.forEach(function (s) { s.addEventListener('change', updateVariant); });
  }

  var buyRow = root.querySelector('.product-info__buy-row');
  var stickyBar = document.getElementById('ProductStickyBar');
  if (buyRow && stickyBar && 'IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        stickyBar.style.display = entry.isIntersecting ? 'none' : 'flex';
      });
    });
    observer.observe(buyRow);
  }
})();

